'use es6';

import { createSelector } from 'reselect';
import { List } from 'immutable';
import { getContent } from './contentSelectors';
export const getLessons = state => state.lessons ? state.lessons.get('lessonsById') : null;
export const getLessonIds = createSelector(getLessons, lessons => {
  return lessons.map(lesson => lesson.get('id'));
});
export const getCategoriesFromLessons = createSelector(getLessons, lessons => lessons.map(lesson => lesson.get('categories')).toSet().flatten());
export const getLesson = createSelector(getLessons, (state, props) => `${props.lessonId}`, (lessons, lessonId) => lessons ? lessons.get(lessonId) : null);
export const makeGetLesson = () => getLesson;
export const lessonIsLoading = createSelector(getLesson, lesson => lesson ? lesson.get('isRequesting') : true);
export const lessonHasError = createSelector(getLesson, lesson => lesson ? lesson.get('hasError') : false);
export const canOperateOnLesson = createSelector(getLesson, lessonIsLoading, (lesson, isLoading) => !isLoading && !lesson.get('hasError'));
export const getContentForLesson = createSelector(getLesson, canOperateOnLesson, getContent, (lesson, lessonIsReady, contentById) => {
  if (!lessonIsReady || !lesson) {
    return undefined;
  }

  const contentIds = lesson.get('contentIds');
  return contentIds.map(contentId => contentById.get(contentId));
});
export const makeGetContentForLesson = () => getContentForLesson;
export const getLessonIsAnyType = createSelector((__, props) => props.types, getLesson, (types, lesson) => !!(lesson && lesson.get('lessonType') && lesson.get('lessonType').toSet().intersect(types).size));
export const getLessonsAreRequesting = state => {
  return state && state.lessons && (state.lessons.get('isRequesting') || state.lessons.get('isRequestingSearch') || state.lessons.get('isRequestingPartner'));
};
export const getLessonName = createSelector(getLesson, lesson => {
  if (!lesson) {
    return '';
  }

  return lesson.get('name', '');
});
export const getLessonLanguage = createSelector(getLesson, lesson => {
  if (!lesson) {
    return '';
  }

  return lesson.get('language', '');
});
export const getLessonSubcategories = createSelector(getLesson, lesson => {
  if (!lesson) {
    return List();
  }

  return lesson.get('subCategories', List());
});
export const getLessonDuration = createSelector(getLesson, lesson => lesson && lesson.get('duration'));
export const getNextLessonContentUrl = createSelector(getLesson, (_, props) => props.contentId, (lesson, contentId) => {
  if (!lesson) return null;
  const contentIds = lesson.get('contentIds');
  if (!contentIds) return null;
  const currentIndex = contentIds.indexOf(contentId);
  const contentIsLastInLesson = currentIndex >= contentIds.count() - 1;

  if (contentIsLastInLesson) {
    return `/lessons/${lesson.get('id')}/recommendations`;
  }

  const nextContentId = contentIds.get(currentIndex + 1, null);
  return `/lessons/${lesson.get('id')}/${nextContentId}`;
});